import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { appInsightsData } from "src/helper/AppInsightsData";
import { logger } from "src/routes/LoggedIn";

const SideMenuMySettings: React.FC = () => {
    const [activeTab, setActiveTab] = useState<string | null>("/my-settings/authentication-questions");

    const navigate = useNavigate(),
        menuList = [
            { name: "Authentication Questions", route: "/authentication-questions", icon: "AuthQuestions" },
            { name: "Message Options", route: "/message-options", icon: "MessageOptions" },
            { name: "Mailbox Delegation", route: "/mailbox-delegation", icon: "MailboxDelegation" },
            { name: "Notifications", route: "/notifications", icon: "NotificationOptionIcon" },
            { name: "Email Template", route: "/email-template", icon: "EmailTemplateIcon" },
            { name: "Default Tax Year", route: "/default-tax-year", icon: "DefaultTaxYearIcon" },
        ];

    const handleSelect = (key: string | null) => {
        key && navigate(key);
        setActiveTab(key);
    };

    useEffect(() => {
        if (activeTab.includes(menuList[0].route)) {
            logger.trackPageView(appInsightsData.MySettings.AuthQuestions.PageTitle);
        } else if (activeTab.includes(menuList[1].route)) {
            logger.trackPageView(appInsightsData.MySettings.MessageOption.PageTitle);
        } else if (activeTab.includes(menuList[2].route)) {
            logger.trackPageView(appInsightsData.MySettings.MessageDelegation.PageTitle);
        }
    }, [activeTab]);

    return (
        <div className="admin-side-menu-wrapper settings-sidebar">
            <Nav
                defaultActiveKey="/my-settings/authentication-questions"
                className="flex-column"
                onSelect={key => handleSelect(key)}
            >
                {menuList.map((data, key) => {
                    return (
                        <Nav.Link
                            className="settings-menu-item nav-link"
                            eventKey={`/my-settings${data.route}`}
                            key={key}
                        >
                            {data.name}
                        </Nav.Link>
                    );
                })}
            </Nav>
        </div>
    );
};

export default SideMenuMySettings;
